import { render, staticRenderFns } from "./ProductStockModal.Style#Drawer.vue?vue&type=template&id=079db27c&scoped=true&"
import script from "./ProductStockModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./ProductStockModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockModal.Style#Drawer.vue?vue&type=style&index=0&id=079db27c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079db27c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079db27c')) {
      api.createRecord('079db27c', component.options)
    } else {
      api.reload('079db27c', component.options)
    }
    module.hot.accept("./ProductStockModal.Style#Drawer.vue?vue&type=template&id=079db27c&scoped=true&", function () {
      api.rerender('079db27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/stock/modules/ProductStockModal.Style#Drawer.vue"
export default component.exports